import styled, { css } from 'styled-components';
import { COLORS } from 'assets/styled/colors';
import { respondTo } from 'assets/styled/breakpoints';

interface StyledProps {
  isSelected: boolean;
  darkMode: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.WHITE};
  width: 100%;
  min-width: 1000rem;
  position: fixed;
  z-index: 200;
  border-bottom: 1rem solid ${COLORS.GRAY_100};

  ${respondTo.bigTablet`
    min-width: auto
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  svg {
    height: auto !important;

    ${respondTo.smallLaptop`
      width: 100rem !important;
    `}
  }
`;

export const SelectedModeLabel = styled.label`
  font-weight: 600;
  font-size: 16rem;
  color: ${(StyledProps: StyledProps) =>
    StyledProps.darkMode ? COLORS.GRAY_300 : COLORS.BLACK};
  text-transform: uppercase;

  ${respondTo.smallPhone`
    font-size: 13rem;
  `}
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  ${respondTo.smallTablet`
    gap: 20rem;
  `}
`;

export const NavigationLabel = styled.label`
  cursor: pointer;
  font-weight: 400;
  ${(props: StyledProps) =>
    props.isSelected
      ? css`
          color: ${COLORS.GREEN};
          transform: scale(1.01);
          transition: ease 100ms;
          font-weight: 600;
        `
      : css`
          color: ${COLORS.BLACK};
          transition: ease 100ms;
        `}
`;

export const RowSpaceBetween = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 75rem;
  max-width: 1440rem;
  width: 100%;
  align-self: center;

  ${respondTo.smallLaptop`
    padding: 0rem 15rem;
  `}
`;

export const SwitchersWrapper = styled.div`
  gap: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ${respondTo.smallLaptop`
    gap: 20rem;
  `}
`;

export const HeaderIconWrapper = styled.div`
  position: relative;

  ${respondTo.smallPhone`
    position: static;
  `}
`;
